import { StateSchema } from 'app/config/storeConfig/types';
import { ContractAgreementSchema } from '../types';

export const getContractAgreementState = (state: StateSchema): ContractAgreementSchema => state.contractAgreementModal;
